import { render, staticRenderFns } from "./TransienceCerebralIschemiaSystem.vue?vue&type=template&id=7aeccd6b&scoped=true&"
import script from "./TransienceCerebralIschemiaSystem.vue?vue&type=script&lang=js&"
export * from "./TransienceCerebralIschemiaSystem.vue?vue&type=script&lang=js&"
import style0 from "./TransienceCerebralIschemiaSystem.vue?vue&type=style&index=0&id=7aeccd6b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aeccd6b",
  null
  
)

export default component.exports